import { UpsertConstruction } from "@/types/Views/CreateConstruction/NewConstruction";

export const constructionTemplate: UpsertConstruction = {
  categoryId: undefined,
  id: undefined,
  declaredUnit: {
    unitId: -1,
    value: 0,
  },
  descriptions: [],
  inhomogeneousLayers: [],
  internalId: undefined,
  isCustom: false,
  isPublic: false,
  materials: [],
  names: [],
};
